export default __webpack_public_path__ + "static/girl-937c211552dab6b7933f19c1d0df6c1c.png";